import { MenuItem } from '../domain/menuItem.model';

export const MENU: MenuItem[] = [
  { name: 'داشبورد', path: '/main/dashboard' },
  // { name: 'ارزها', path: '/main/assets' },
  // { name: 'کیف پول', path: '/main/wallet' },
  { name: 'تراکنش‌ها', path: '/main/transactions' },
  { name: 'پشتیبانی', path: '/main/support' },
];
